import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
    stackSpacing,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const ZoomAccessFailureWindowField = ({ darkMode, disabled = false }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Access Failure Window
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Time window (in minutes) for tracking access failures.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NumberField}
                            id="accessFailureWindow"
                            name="accessFailureWindow"
                            placeholder="0"
                            width="100%"
                            darkMode={darkMode}
                            disabled={disabled}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Time window (in minutes) for tracking access failures."
                        ariaLabel="zoom-access-failure-window-tip"
                        right="20px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ZoomAccessFailureWindowField;
